import { useState } from "react"
import { Getter } from "./services/ComService"
import { Box } from "@mui/material"

export default function TestMail() {
    const [output, setOutput] = useState('')
    const [status, setStatus] = useState('idle')
    async function work(target: string) {
        setOutput('working')
        const res = await Getter('test/emailtohauke')
        setOutput(JSON.stringify(res))
        setStatus('idle')
    }
    return <Box
        sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'start',
            gap: 2,
            margin: 2,
        }}
    >  
        <h1>Test Mail</h1>
        <button
            onClick={async () => {
                await work('test/emailtohauke')
            }}
        >Testmail Hauke</button>
        <button
            onClick={async () => {
                await work('test/emailtopatrick')
            }}
        >Testmail Patrick</button>
        <div>{status}</div>
        <pre>{output}</pre>
    </Box>
}
